<div class="container">
  <mat-card>
    <form [formGroup]="delinquencyRangeForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Classification' | translate }}</mat-label>
            <input matInput required formControlName="classification" />
            @if (delinquencyRangeForm.controls.classification.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Classification' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Days From' | translate }}</mat-label>
            <input matInput type="number" required formControlName="minimumAgeDays" min="1" />
            @if (delinquencyRangeForm.controls.minimumAgeDays.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Days From' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
            @if (delinquencyRangeForm.controls.minimumAgeDays.hasError('pattern')) {
              <mat-error> {{ 'labels.inputs.Days From' | translate }} must be a positive number. </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Days Till' | translate }}</mat-label>
            <input matInput type="number" formControlName="maximumAgeDays" />
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!delinquencyRangeForm.valid"
          *LOSxHasPermission="'CREATE_DELINQUENCY_RANGE'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
